// toastBus — REFORMA E3a (monit 1207R zad. 11/12): jeden kanał toastów dla całej
// aplikacji zamiast natywnych alert() przeglądarki. Bez Reacta (testowalny w node);
// ekran: components/ui/ToastHost.jsx (montowany raz w main.jsx).

const listeners = new Set();
let seq = 0;

/**
 * @param {string} text
 * @param {{ kind?: 'info'|'warn'|'error'|'ok', ms?: number }} [opts]
 * @returns {number} id toastu
 */
export function showToast(text, opts = {}) {
  const t = { id: ++seq, text: String(text ?? ''), kind: opts.kind || 'info', ms: Number(opts.ms) || 4000, at: Date.now() };
  for (const fn of listeners) {
    try { fn(t); } catch { /* słuchacz nie może wywrócić nadawcy */ }
  }
  return t.id;
}

export function subscribeToasts(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Do testów: liczba słuchaczy. */
export function __toastListeners() { return listeners.size; }
